import { gql } from '@apollo/client/core';

export const CARETYPE_GEOPAGE_QUERY = gql`
  query ($first: Int!, $geoPointX: Decimal!, $geoPointY: Decimal!, $careType: String!) {
    sitterSearch(first: $first, searchParams: { careType: $careType, geoPoint: { x: $geoPointX, y: $geoPointY } }) {
      edges {
        cursor
        node {
          sitter {
            id
            name
            photoUrl
          }
          avgRating
          totalRatings
          distance
          yearsExperience
          description
          hasFirstAidTraining
          minRate
          maxRate
          cprCertified
          basicBackgroundCheckExpiry
          enhancedBackgroundCheckExpiry
          vehicleBackgroundCheckExpiry
        }
      }
    }
  }
`;

export const CHILD_CARE_GEOPAGE_QUERY = gql`
  query ($first: Int!, $geoPointX: Decimal!, $geoPointY: Decimal!) {
    babysitter: sitterSearch(
      first: $first
      searchParams: { careType: "babysitter", geoPoint: { x: $geoPointX, y: $geoPointY } }
    ) {
      edges {
        cursor
        node {
          sitter {
            id
            name
            photoUrl
          }
          avgRating
          totalRatings
          distance
          yearsExperience
          description
          hasFirstAidTraining
          minRate
          maxRate
          cprCertified
          basicBackgroundCheckExpiry
          enhancedBackgroundCheckExpiry
          vehicleBackgroundCheckExpiry
        }
      }
    }

    nanny: sitterSearch(first: $first, searchParams: { careType: "nanny", geoPoint: { x: $geoPointX, y: $geoPointY } }) {
      edges {
        cursor
        node {
          sitter {
            id
            name
            photoUrl
          }
          avgRating
          totalRatings
          distance
          yearsExperience
          description
          hasFirstAidTraining
          minRate
          maxRate
          cprCertified
          basicBackgroundCheckExpiry
          enhancedBackgroundCheckExpiry
          vehicleBackgroundCheckExpiry
        }
      }
    }
  }
`;

export const SEARCH_AVAILABILITIES_QUERY = gql`
  query ($searchParams: SitterSearchInput!, $first: Int, $after: String) {
    sitterSearch(searchParams: $searchParams, first: $first, after: $after) {
      ... on SitterSearchResultConnection {
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
        }
        edges {
          cursor
          node {
            sitter {
              id
              name
              photoUrl
              location {
                cityname
                stateabbr
              }
              idv {
                verdict
              }
            }
            availability {
              start
              end
            }
            avgRating
            totalRatings
            distance
            yearsExperience
            description
            hasFirstAidTraining
            minRate
            maxRate
            cprCertified
            basicBackgroundCheckExpiry
            enhancedBackgroundCheckExpiry
            vehicleBackgroundCheckExpiry
            isVolunteerProvider
          }
        }
      }
    }
  }
`;

export const SITTER_AVERAGE_PAY_RATE = gql`
  query ($geoPointX: Decimal!, $geoPointY: Decimal!, $careType: String!, $minRate: Int, $rate: Int) {
    sitterSearch(
      searchParams: { careType: $careType, geoPoint: { x: $geoPointX, y: $geoPointY }, rate: $rate, minRate: $minRate }
    ) {
      averagePayRate
    }
  }
`;

export default {
  search_availabilities: SEARCH_AVAILABILITIES_QUERY,
  CHILD_CARE_GEOPAGE_QUERY,
  CARETYPE_GEOPAGE_QUERY,
};
